export const teamDirectory = {
  contacts: [
    { name: 'Head of Design', role: 'Design Leadership', email: 'head-of-design@company.com', slack: '@head-design' },
    { name: 'Product Design Lead', role: 'Design Leadership', email: 'product-design-lead@company.com', slack: '@product-design-lead' },
    { name: 'Product Manager', role: 'Product Strategy', email: 'product-manager@company.com', slack: '@product-manager' },
    { name: 'Engineering Manager', role: 'Development Lead', email: 'eng-manager@company.com', slack: '@eng-manager' }
  ],
  mentors: [
    { name: 'Senior Product Designer Mentor', expertise: 'End-to-end Product Design & Strategy', availability: 'Mon-Fri 2-4 PM' },
    { name: 'Design Systems Mentor', expertise: 'Design Systems & Component Libraries', availability: 'Tue/Thu 10 AM-12 PM' },
    { name: 'Product Strategy Mentor', expertise: 'Product Vision & User Experience Strategy', availability: 'Wed/Fri 3-5 PM' }
  ],
  collaborators: [
    { team: 'Product Team', contact: 'product-team@company.com', purpose: 'Product Strategy & Feature Planning' },
    { team: 'Engineering Team', contact: 'engineering-team@company.com', purpose: 'Design Implementation & Technical Feasibility' },
    { team: 'UX Research Team', contact: 'ux-research@company.com', purpose: 'User Research & Validation' },
    { team: 'Marketing Team', contact: 'marketing-team@company.com', purpose: 'Brand Alignment & Go-to-Market Strategy' }
  ],
  channels: {
    primary: '#product-design',
    announcements: '#design-announcements',
    help: '#design-help',
    systems: '#design-systems',
    critique: '#design-critique',
    research: '#design-research',
    collaboration: '#product-design-collab'
  }
};
